// import { useState } from "react";
// import axios from "axios";

// export default function ContactUs() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };


//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     await axios.post("http://localhost:8080/api/contact", formData);
//     alert("Message sent successfully!");
//     setFormData({ name: "", email: "", message: "" });
//   } catch (error) {
//     alert("Something went wrong!");
//     console.error(error);
//   }
// };


//   return (
//     <div className="container mt-5 mb-5">
//       <div className="text-center mb-4">
//         <h1 className="fw-bold">📞 Contact Us</h1>
//         <p className="text-muted">
//           We'd love to hear from you. Get in touch with us!
//         </p>
//       </div>

//       <div className="row g-4">
//         {/* CONTACT FORM */}
//         <div className="col-md-6">
//           <div className="card shadow-sm p-4">
//             <h4 className="mb-3">Send us a message</h4>

//             <form onSubmit={handleSubmit}>
//               <div className="mb-3">
//                 <label className="form-label">Your Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Email Address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Message</label>
//                 <textarea
//                   className="form-control"
//                   rows="4"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <button className="btn btn-primary w-100 fw-bold">
//                 Send Message
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* CONTACT INFO + MAP */}
//         <div className="col-md-6">
//           <div className="card shadow-sm p-4 mb-4">
//             <h4>Contact Information</h4>

//             <p className="mb-1">
//               <strong>📍 Address:</strong> Vijaynagar, Sangli, Maharashtra
//             </p>
//             <p className="mb-1">
//               <strong>📧 Email:</strong> nivararesort@gmail.com
//             </p>
//             <p className="mb-1">
//               <strong>📞 Phone:</strong> +91 98765 43210
//             </p>

//             <hr />

//             <h5>Follow Us</h5>
//             <div className="d-flex gap-3 fs-4">
//               <a href="#" className="text-primary">
//                 <i className="bi bi-facebook"></i>
//               </a>
//               <a href="#" className="text-danger">
//                 <i className="bi bi-instagram"></i>
//               </a>
//               <a href="#" className="text-info">
//                 <i className="bi bi-twitter"></i>
//               </a>
//               <a href="#" className="text-success">
//                 <i className="bi bi-whatsapp"></i>
//               </a>
//             </div>
//           </div>

//           {/* GOOGLE MAP */}
//           <div className="card shadow-sm">
//             <iframe
//               title="Google Map"
//               src="https://www.google.com/maps?q=Sangli%20Maharashtra&output=embed"
//               width="100%"
//               height="250"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//             ></iframe>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



//*********VALIDATION CODE*******//

// import { useState } from "react";
// import axios from "axios";

// export default function ContactUs() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [success, setSuccess] = useState("");

//   // HANDLE INPUT CHANGE
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // VALIDATION
//   const validate = () => {
//     let newErrors = {};

//     if (!form.name.trim()) {
//       newErrors.name = "Name is required";
//     }

//     if (!form.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (
//       !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)
//     ) {
//       newErrors.email = "Invalid email format";
//     }

//     if (!form.message.trim()) {
//       newErrors.message = "Message cannot be empty";
//     } else if (form.message.length < 10) {
//       newErrors.message = "Message must be at least 10 characters";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // SUBMIT
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;

//     try {
//       await axios.post("http://localhost:8080/api/contact", form);
//       setSuccess("Message sent successfully!");
//       setForm({ name: "", email: "", message: "" });
//       setErrors({});
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <div className="container mt-5">
//       <h2 className="mb-4">📩 Contact Us</h2>

//       {success && <div className="alert alert-success">{success}</div>}

//       <form onSubmit={handleSubmit} noValidate>
//         <div className="mb-3">
//           <label>Name</label>
//           <input
//             name="name"
//             className={`form-control ${errors.name && "is-invalid"}`}
//             value={form.name}
//             onChange={handleChange}
//           />
//           <div className="invalid-feedback">{errors.name}</div>
//         </div>

//         <div className="mb-3">
//           <label>Email</label>
//           <input
//             name="email"
//             className={`form-control ${errors.email && "is-invalid"}`}
//             value={form.email}
//             onChange={handleChange}
//           />
//           <div className="invalid-feedback">{errors.email}</div>
//         </div>

//         <div className="mb-3">
//           <label>Message</label>
//           <textarea
//             name="message"
//             rows="4"
//             className={`form-control ${errors.message && "is-invalid"}`}
//             value={form.message}
//             onChange={handleChange}
//           />
//           <div className="invalid-feedback">{errors.message}</div>
//         </div>

//         <button className="btn btn-primary">Send Message</button>
//       </form>
//     </div>
//   );
// }

//********UI Design Code********/
import React, { useState } from "react";
import "./ContactUs.css";

const C = {
  forest: "#16261F",
  forest2: "#1F3529",
  brick: "#A8452F",
  moss: "#4B6B4F",
  river: "#2E6E6A",
  sand: "#EFE8D6",
  sandDeep: "#E4DBC3",
  gold: "#C79A3E",
  ink: "#1E241F",
  cream: "#F5F0E3",
  creamDim: "#CFCBBB",
};



export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  // 🔹 Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔹 Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill all fields");
      return;
    }

    setStatus("Sending...");

    try {
      const response = await fetch("http://localhost:8080/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Failed to send");

      setFormData({ name: "", email: "", message: "" });
      setStatus("Message sent successfully!");
    } catch (error) {
      console.error(error);
      setStatus("Server error. Please try again.");
    }
  };

  return (
    <div className="contact-page-wrapper py-5">
      <div className="container">
        <div className="inner-contact-container shadow-lg">
          <div className="row g-0">

            {/* LEFT SIDE: FORM */}
            <div className="col-lg-6 p-5 bg-white">
              <div className="tile1-heading mb-3">Get in touch</div>
              {/* <p className="text-muted mb-4">
                We are here for you! How can we help?
              </p> */}

              <h2 className="mt-3 mb-8" style={{ fontFamily: "Fraunces, serif", fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 700,
    color: "#000000" }}>
              We're here for you. How can we help?
            </h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    placeholder="Enter your email address"
                    required
                  />
                </div>

                <div className="mb-3">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control form-field-custom"
                    rows="4"
                    placeholder="Go ahead we are listening..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-roberto-contact w-100 py-3 fw-bold"
                >
                  SUBMIT
                </button>

                {status && (
                  <p className="mt-3 small text-center">{status}</p>
                )}
              </form>
            </div>

            {/* RIGHT SIDE: IMAGE & INFO */}
            <div
              className="col-lg-6 p-5 text-dark"
              style={{ backgroundColor: "#fff", borderLeft: "1px solid #eee" }}
            >
              <div className="tile2-image mb-4 text-center">
                <img
                  src="/images/contact.png"
                  alt="Contact Graphic"
                  className="img-fluid"
                  style={{ maxHeight: "250px", objectFit: "contain" }}
                />
              </div>

              <div className="ps-lg-4">
                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/location.png" alt="Loc" width="16" />
                  </div>
                  <span className="fw-semibold">
                    Tapola Vanavli, T. Solasi, Maharashtra 412806
                  </span>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/phone.png" alt="Phone" width="16" />
                  </div>
                  <span className="fw-semibold">+91 82756 07686</span>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <div className="contact-icon-circle me-3">
                    <img src="/images/mail.png" alt="Mail" width="16" />
                  </div>
                  <span className="fw-semibold">
                    nivaraagrotourism@gmail.com
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      

    </div>



  );


  
}


